/* ==================================================
# HelperFunctions
#Header
#Product
#Footer
*/

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints
}

/*============================================================================
  Header
==============================================================================*/

var header = {
  init: function () {

  $(document).ready(function() { 
   
    $(".site-nav--has-dropdown").on({
    mouseenter: function (e) {
        //stuff to do on mouse enter
      if (e.target.parentElement.querySelectorAll("span").length > 0) {
        e.target.parentElement.querySelectorAll("span")[0].classList.add("active-hover")
      }
    },
    mouseleave: function (e) {
     
     if (e.target.parentElement.querySelectorAll("span").length > 0) {
        e.target.parentElement.querySelectorAll("span")[0].classList.remove("active-hover")
      }
    }
  });

    $(".site-nav__dropdown").on({
    mouseenter: function (e) {
        //stuff to do on mouse enter
    
    },
      mouseleave: function (e) {
        
        if (e.target.parentElement.querySelectorAll("span").length > 0) {
          
          e.target.parentElement.querySelectorAll("span")[0].classList.remove("active-hover")
        }
      }
    });

  });




    var closeDropdown = function () {
      backFromSecondLevel()
      backFromThirdLevel()

      gsap.to('.subnav-panel', {
        transform: 'translateX(200%)',
        duration: 0.5,
        ease: 'slow(0.7, 0.7, false)',
      })

       gsap.to('.mobile-navigation-wrapper', {
         transform: 'translateX(100%)',
         duration: 0.5,
         ease: 'slow(0.7, 0.7, false)',
       })
      document.body.style.overflowY = 'unset'
      document.body.style.overflowX = 'unset'
      $('.mobile-navigation-wrapper').fadeOut()
      document.getElementById('navbar').style.marginTop = '45px'
      $('main').fadeIn()
      $('footer').fadeIn()

      /** RESET LEVELS **/
      document
        .querySelectorAll('ul.second-level > li > div.subnav-panel')
        .forEach(function (elem) {})
        
      document
        .querySelectorAll('ul.second-level > li')
        .forEach(function (elem) {
          elem.style.display = 'block'
          elem.classList.remove('nav-active')
        })

      document.querySelectorAll('ul.main > li').forEach(function (elem) {
        elem.style.display = 'block'
        elem.style.opacity = 1
        elem.classList.remove('parent-nav-active')
      })
      // document
      //   .querySelectorAll('ul.second-level > li > button')
      //   .forEach(function (elem) {
      //     elem.style.display = 'none'
      //   })

      // const allSubpanels = document.getElementsByClassName('subnav-panel')

      // allSubpanels.forEach(function (elem) {
      //   elem.style.transform = 'translateX(200%)'
      // })
    }

    var openDropdownMobile = function () {
      document.body.style.overflowY = 'hidden'
      document.body.style.overflowX = 'hidden'
      document.getElementsByClassName('mobile-navigation-wrapper')[0].style.display = "flex"
      
      document.getElementById('navbar').style.marginTop = '0px'
      $('main').fadeOut()
      $('footer').fadeOut()
      $('.valign').fadeIn()

      gsap.to('.mobile-navigation-wrapper', {
        transform: 'translateX(0%)',
        duration: 0.5,
        ease: 'slow(0.7, 0.7, false)',
      })

      document
        .querySelectorAll('ul.second-level > li > button')
        .forEach(function (elem) {
          elem.style.display = 'none'
        })


    }

    var dropDownSelector = function (e) {
      const navElem = $(e).closest('li').addClass('parent-nav-active')
      gsap.to(
        '#navbar > nav > div.valign > ul.main > li.parent-nav-active > div',
        {
          transform: 'translateX(0%)',
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        }
      )
      const allNotActiveLi = document.querySelectorAll(
        "ul.main > li:not([class='parent-nav-active'])"
      )
      allNotActiveLi.forEach(function (elem) {
        gsap.to(elem, {
          opacity: 0,
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        })
      })
      allNotActiveLi.forEach(function (elem) {
        gsap.to(elem, {
          display: "none",
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        })
      })
    }

    var backToMainMenu = function () {
      gsap.to(
        '#navbar > nav > div.valign > ul.main > li.parent-nav-active > div',
        {
          transform: 'translateX(100%)',
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        }
      )
      const allNotActiveLi = document.querySelectorAll('ul.main > li')
      allNotActiveLi.forEach(function (elem) {
        gsap.to(elem, {
          opacity: 1,
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        })
        gsap.to(elem, {
          display: "block",
          duration: 0.1,
          ease: 'slow(0.3, 0.3, false)',
        })
        elem.classList.remove('parent-nav-active')
      })
    }

    var selectSecondLevel = function (e) {
      console.log('we execyted ')
     // const navElem = $(e).closest('li').addClass('nav-active')
      e.parentElement.classList.add("nav-active")
    
      

      const gsapVal =
        '#navbar > nav > div.valign > ul.main > li.parent-nav-active > div > ul > li.nav-active > div.subnav-panel'
   
      gsap.to(gsapVal, {
        transform: 'translateX(0%)',
        duration: 0.5,
        ease: 'slow(0.7, 0.7, false)',
      })

      const allNotActiveLi = document.querySelectorAll(
        "ul.second-level > li:not([class='nav-active'])"
      )
      console.log(allNotActiveLi.length)
      document.querySelectorAll("li.parent-nav-active > div.subnav-panel > ul.second-level > li").forEach(function(elem){
            if (!elem.classList.contains("nav-active")){
            gsap.to(elem, {
            opacity: 0,
            duration: 0.5,
            ease: 'slow(0.7, 0.7, false)',
            })

            elem.style.display = "none"
        }
      })
      
      document.querySelectorAll('.parent-nav-active > div')[0].style.display = 'block'
    }

    var backFromSecondLevel = function () {
      if (
        document.querySelectorAll('ul.second-level > li.nav-active > button')
          .length > 0
      ) {
        document.querySelectorAll(
          'ul.second-level > li.nav-active > button'
        )[0].style.display = 'none'

        const gsapVal =
          '#navbar > nav > div.valign > ul.main > li.parent-nav-active > div > ul > li.nav-active > div.subnav-panel'
        gsap.to(gsapVal, {
          transform: 'translateX(100%)',
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        })
        const allNotActiveLi = document.querySelectorAll('ul.second-level > li.second-level-child')
        allNotActiveLi.forEach(function (elem) {
         
          console.log(elem)
          gsap.to(elem, {
            opacity: 1,
            duration: 0.5,
            ease: 'slow(0.7, 0.7, false)',
          })

          
          elem.classList.remove('nav-active')
        })
      }
    }

    var backFromThirdLevel = function () {
      if (
        document.querySelectorAll('ul.second-level > li.nav-active > button')
          .length > 0
      ) {
        document.querySelectorAll(
          'ul.second-level > li.nav-active > button'
        )[0].style.display = 'none'

        const gsapVal =
          '#navbar > nav > div.valign > ul.main > li.parent-nav-active > div > ul > li.nav-active > div.subnav-panel'
        gsap.to(gsapVal, {
          transform: 'translateX(100%)',
          duration: 0.5,
          ease: 'slow(0.7, 0.7, false)',
        })
        const allNotActiveLi = document.querySelectorAll('ul.second-level > li')
        allNotActiveLi.forEach(function (elem) {
           elem.style.display = "block"
          gsap.to(elem, {
            opacity: 1,
            duration: 0.5,
            ease: 'slow(0.7, 0.7, false)',
          })
          elem.classList.remove('nav-active')
        })
      }
    }

    $('body').on('click touchend', '.close-mobile-nav-icon', function () {
      
      closeDropdown()
    })

    $('body').on('click touchend', '#mobileNavOpen', function () {
      openDropdownMobile()
    })

    $('body').on('click touchend', '.main > li:has(div) > a', function (e) {
      dropDownSelector(this)
    })

    $('body').on('click touchend', '.second-level > li:has(div) > a.a-second', function (
      e
    ) {
      selectSecondLevel(this)
    })

    $('body').on('touchend', '#backToMainMenu', function () {
      backToMainMenu()
    })

    $('body').on('touchend', '#backFromSecondLevel', function () { 
      backFromSecondLevel()
    })

    $('body').on('touchend', '#backFromThirdLevel', function () {
      backFromThirdLevel()
    })

  },
}

var productPage = {
  init: function () {
    console.log('productPage loaded')
    
  },
}

var footer = {
  init: function () {
    console.log('footer loaded')
    

    // MOBILE
    

  },
}
